"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactFeatures = require("./ContactFeatures");
Object.keys(_ContactFeatures).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactFeatures[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactFeatures[key];
    }
  });
});